import cssVariables                                                  from "./cssVariables";
import { buttonsColorLight, buttonsColorDark, light, dark, palette } from "./colors";
import { defaultVariantMapping, fontSizeMapping, fontWeightMapping } from "./typography";

export const themeLight = {
	primaryColor   : "#ffffff",
	secondaryColor : "linear-gradient(to top, #439aff, #126bd5)",
	inputBgColor   : "#f3f3f3",
	inputColor     : "#797979",
	color          : "#000000",
	borderColor    : "#e7e7e7",
	iconColor      : "#126bd5",
	boxShadow      : "rgba(0, 0, 0, 0.16) 0px 0px 6px 0px"
};

const typographyNew = {
	defaultVariantMapping, fontSizeMapping, fontWeightMapping
};

export {
	cssVariables,
	buttonsColorLight,
	buttonsColorDark,
	light,
	dark,
	palette,
	typographyNew
};
